import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";
import CustomCheckbox from "../../atoms/CustomCheckbox";
import Buttons from "../../atoms/Buttons";
import "./bank-mandate-details.scss";
import { RA_STEPS_IDENTIFIERS } from "../../constants/constants";
import BankMandateForm from "../BankMandateForm";
import { useSelector } from "react-redux";

const BankMandateDetails = (props) => {
  const { bankDetails } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const [editStatus, setEditStatus] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [showLoaderBank, setShowLoaderBank] = useState(false);
  const [isBankAccount, setIsBankAccount] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [id3StatusBank, setId3StatusBank] = useState(false);
  const [showBankDetails, setShowBankDetails] = useState(false);
  const [getBankDetails, setGetBankDetails] = useState(false);
  const [btnEnable, setBtnEnable] = useState(false);
  const { swiftInfoChecked, setSwiftInfoChecked } = props;

  useEffect(() => {
    if (bankDetails?.swift) {
      setIsBankAccount(false);
      setShowBankDetails(true);
      setSwiftInfoChecked(false);
    } else if (bankDetails?.sortCodeVal) {
      setIsBankAccount(true);
      setShowBankDetails(true);
    }
  }, []);

  const handleCheckboxChange = (event) => {
    setSwiftInfoChecked(event.target.checked);
  };

  const editIconHandler = (status) => {
    setEditStatus(status);
  };

  const handleBack = () => {
    props.makeInitialStepper(true);
  };

  const handleContinue = () => {
    setGetBankDetails(true);
  };
  const uploadClick = (e) => {
    e.preventDefault();
  };
  const buttonEnable = (btnCheck) => {
    setBtnEnable(btnCheck);
  };
  // eslint-disable-next-line no-unused-vars
  const confirmAPIHandler = (reqData, changedField, workItemType) => {
    props.nextStepIndentifier(
      RA_STEPS_IDENTIFIERS.BANK_MANDATE,
      reqData,
      workItemType,
    );
  };
  return (
    <>
      <Card className="application-step">
        <Card.Body className="bank-mandate-details">
          <Row>
            <Col md={12} className="mb-fourty">
              <p className="guidance ">Bank mandate</p>
            </Col>
          </Row>
          <Row className="ourter-bg">
            <Col md={9} className="bg-text">
              <p>Enter your payment details so we can send you your payment.</p>
              <p>
                We will use third-party provider to validate your payment
                instuctions and you would be consenting to us sharing this
                information securely to perform these checks.
              </p>
              <p>
                Please have a copy of a recent bank statement ready to upload in
                the next step (less than 3 months old, make sure that it
                includes your name and address).
              </p>
              <p>
                For your security, if you pause this application process,
                you&apos;ll need to re-enter these details.
              </p>
            </Col>
          </Row>

          <Row>
            <Col md={12} className="bg-text">
              <p className="question">Do you have a UK bank account?</p>
              <div className="check_box">
                <CustomCheckbox
                  name="pension-wise-guidance"
                  label="Yes"
                  variantName="custom-checkbox"
                  checked={isBankAccount && showBankDetails}
                  onChange={() => {
                    setIsBankAccount(true);
                    setShowBankDetails(true);
                    setSwiftInfoChecked(false);
                  }}
                />
                <CustomCheckbox
                  name="pension-wise-guidance"
                  label="No"
                  variantName="custom-checkbox"
                  checked={!isBankAccount && showBankDetails}
                  onChange={() => {
                    setIsBankAccount(false);
                    setShowBankDetails(true);
                    // setSwiftEnabled(true);
                  }}
                />
              </div>
            </Col>
          </Row>
          {showBankDetails && (
            <Row className="ourter-bg mt-4">
              <Col md={10} className="bg-text">
                <BankMandateForm
                  bankdetails={[]}
                  memberType={props?.memberType}
                  confirmAPIHandler={confirmAPIHandler}
                  edit={editStatus}
                  editIconHandler={editIconHandler}
                  id3Status={id3StatusBank}
                  uploadClick={uploadClick}
                  showLoader={showLoaderBank}
                  isBankAccount={isBankAccount}
                  getBankDetails={getBankDetails}
                  setGetBankDetails={setGetBankDetails}
                  buttonEnable={buttonEnable}
                  checked={swiftInfoChecked}
                  onCheckboxChange={handleCheckboxChange}
                  bankDetailPrefilledData={bankDetails}
                />
              </Col>
            </Row>
          )}

          <div className="footer-btn-container">
            <Buttons
              handleClick={handleBack}
              className="secondary back-btn"
              name="Back"
            />

            <Buttons
              handleClick={() => handleContinue()}
              className="primary"
              name="Continue"
              disabled={!btnEnable}
            />
          </div>
        </Card.Body>
      </Card>
    </>
  );
};
export default BankMandateDetails;
